import React from "react";
import IcoMoon from "react-icomoon";
const iconSet = require("./selection.json");

const Ikon = ({ ...props }) => {
  return <IcoMoon iconSet={iconSet} {...props} />;
};

export default Ikon;
